export default __webpack_public_path__ + "static/media/confirmIdentity.7a1fb6ae.svg";